import { MOD_ADMIN_ROUTE, USER_ROUTE } from '@config/routeNames.js'
import { GUIDE_FILTERS_TO_HIDE } from '@config/guides.js'
import { ITEM_TYPES } from '@config/options.js'
import { useRoute } from '@composables'
import { computed } from 'vue'

export default function (game, item, itemTypeRef) {
  const { routeName } = useRoute()

  const hideTags = computed(
    () =>
      !item.value || !game.value || routeName.value.includes(MOD_ADMIN_ROUTE)
  )

  const tagName = computed(() => {
    if (hideTags.value && !routeName.value.includes(USER_ROUTE)) return ''

    const filteredTagOptions = getTagOptions()
    const allTagNames = filteredTagOptions.flatMap((tagGroup) => tagGroup.tags)

    if (itemTypeRef.value === ITEM_TYPES.GUIDE || !game.value) {
      return item.value.tags.find((tag) => allTagNames.includes(tag.name))
    }

    const tagOptionName =
      itemTypeRef.value === ITEM_TYPES.COLLECTION ? 'collection_tags' : 'tags'

    const typeOption = filteredTagOptions?.find(
      (x) => x.name.toLowerCase() === 'type'
    )

    let tagMatch = item.value[tagOptionName].find((tag) =>
      typeOption?.tags?.includes(tag.name)
    )

    if (!tagMatch) {
      tagMatch = item.value[tagOptionName].find((tag) =>
        allTagNames.includes(tag.name)
      )
    }

    return tagMatch
  })

  const subTagName = computed(() => {
    if (
      hideTags.value ||
      itemTypeRef.value === ITEM_TYPES.GUIDE ||
      !tagName.value
    ) {
      return ''
    }

    const filteredTagOptions = getTagOptions()

    const typeOption = filteredTagOptions?.find((tagOption) => {
      const parentTagName = tagName.value?.name?.toLowerCase()
      const optionName = (
        tagOption.name_localized ?? tagOption.name
      ).toLowerCase()

      return (
        tagOption.name.toLowerCase().includes(parentTagName) ||
        parentTagName.includes(optionName)
      )
    })

    const tagOptionName =
      itemTypeRef.value === ITEM_TYPES.COLLECTION ? 'collection_tags' : 'tags'

    const tagMatch = item.value[tagOptionName].find((tag) =>
      typeOption?.tags?.includes(tag.name)
    )

    return tagMatch !== tagName.value ? tagMatch : ''
  })

  function getTagOptions() {
    const toHide = [ITEM_TYPES.COLLECTION, ITEM_TYPES.MOD].includes(
      itemTypeRef.value
    )
      ? []
      : GUIDE_FILTERS_TO_HIDE

    const tagOptionName =
      itemTypeRef.value === ITEM_TYPES.COLLECTION
        ? 'collection_tag_options'
        : 'tag_options'

    switch (itemTypeRef.value) {
      case ITEM_TYPES.COLLECTION:
      case ITEM_TYPES.MOD:
        return game.value[tagOptionName]?.filter(
          (tagOption) =>
            !toHide.includes(tagOption.name?.toLowerCase()) && !tagOption.hidden
        )

      default:
        return [
          {
            tags: item.value.tags
              .filter((tag) => !toHide.includes(tag.name))
              .map((tag) => tag.name),
          },
        ]
    }
  }

  return {
    subTagName,
    tagName,
  }
}
